<template>
  <b-card class="bg-light">
    <div class="json-filters">
      <div class="json-filter-item" v-for="filterField in allFields" :key="filterField.id">
        <div class="json-filter-label">
          <label>{{ filterField.name }}</label>
          <b-form-select v-if="showViewSwitchForTypes.includes(filterField.type_name)"
            class="json-filter-view" :options="viewOptions" size="sm"
            v-model="filters[filterField.lookup_key].view" />
        </div>
        <div class="json-filter-fields">

          <b-form-select v-if="showNullPicker(filterField)"
            class="json-filter-null" :options="nullOptions"
            v-model="filters[filterField.lookup_key].is_null" />

          <template v-if="(filters[filterField.lookup_key].is_null === '') || (!showNullPicker(filterField))">

            <div v-if="filterField.is_set && filterOptions[filterField.id]">
              <treeselect :multiple="true" :searchable="true" :options="filterOptions[filterField.id]" v-model="filters[filterField.lookup_key].exact"/>
            </div>
            <template v-else-if="filterField.type_name === 'Boolean' || filterField.type_name === 'Boolean Array'">

              <b-form-select v-if="filters[filterField.lookup_key].view === 'exact'"
                :options="booleanOptions" v-model="filters[filterField.lookup_key].exact" />
            </template>
            <template v-else-if="filterField.type_name === 'Timestamp' || filterField.type_name === 'Timestamp Array'">
              <div class="d-flex json-filter-range-group">
                <template v-if="filters[filterField.lookup_key].view === 'range'">
                  <div class="d-flex json-filter-range-item">
                  <label>{{ $dt('global.from', 'From') }}</label>
                  <DatePicker format="DD.MM.YYYY hh:mm:ss" value-type="timestamp"
                    v-model="filters[filterField.lookup_key].from" />
                </div>
                <div class="d-flex json-filter-range-item">
                  <label>{{ $dt('global.to', 'To') }}</label>
                  <DatePicker format="DD.MM.YYYY hh:mm:ss" value-type="timestamp"
                    v-model="filters[filterField.lookup_key].to" />
                </div>
                </template>
              </div>
            </template>
            <template v-else-if="filterField.type_name === 'Number' || filterField.type_name === 'Decimal' || filterField.type_name === 'Number Array' || filterField.type_name === 'Decimal Array'">
              <div class="d-flex json-filter-range-group">
                <template v-if="filters[filterField.lookup_key].view === 'exact'">

                  <div class="d-flex json-filter-range-item">
                    <label>{{ $dt('global.exect', 'Exact') }}</label>
                    <b-form-input v-model="filters[filterField.lookup_key].exact" ></b-form-input>
                  </div>
                </template>
                <template v-if="filters[filterField.lookup_key].view === 'range'">
                  <div class="d-flex json-filter-range-item">
                    <label>{{ $dt('global.from', 'From') }}</label>
                    <b-form-input v-model="filters[filterField.lookup_key].from" ></b-form-input>
                  </div>
                  <div class="d-flex json-filter-range-item">
                    <label>{{ $dt('global.to', 'To') }}</label>
                    <b-form-input v-model="filters[filterField.lookup_key].to" ></b-form-input>
                  </div>
                </template>
              </div>
            </template>
            <template v-else-if="filterField.type_name !== 'Object' && filterField.type_name !== 'Object Array'">
              <b-form-input  v-model="filters[filterField.lookup_key].like" ></b-form-input>
            </template>
          </template>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapState } from 'vuex';
import DatePicker from 'vue2-datepicker';
import Treeselect from '@riophae/vue-treeselect';
import Services from '@/services/index';

export default {
  name: 'JsonFilters',
  components: {
    DatePicker,
    Treeselect,
  },
  props: {
    detectionSetId: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      filterFields: [],
      filterOptions: {},
      loading: true,
      filters: {},
      showViewSwitchForTypes: ['Number', 'Number Array', 'Decimal', 'Decimal Array'],
      booleanOptions: [
        { text: this.$dt('global.any', 'Any'), value: '' },
        { text: this.$dt('global.yes', 'Yes'), value: 1 },
        { text: this.$dt('global.no', 'No'), value: 0 },
      ],
      nullOptions: [
        { text: this.$dt('global.any', 'Any'), value: '' },
        { text: this.$dt('global.null', 'Null'), value: 'is_null' },
        { text: this.$dt('global.not_null', 'Not Null'), value: 'is_not_null' },
      ],
      viewOptions: [
        { text: this.$dt('json_filter.exact', 'Exact'), value: 'exact' },
        { text: this.$dt('json_filter.range', 'range'), value: 'range' },
      ]
    };
  },
  computed: {
    ...mapState('Auth', ['activeProjectId', 'token']),
    allFields() {
      const fields = [...this.filterFields];

      return fields.sort((a, b) => {
        // show simple fields first since array fields search is way slower
        if (a.simple_field && !b.simple_field) {
          return -1;
        }
        if (!a.simple_field && b.simple_field) {
          return 1;
        }
        return 0;
      }).filter((field) => {
        // filter out objects and object arrays that are not filter_null
        return !((field.type_name === 'Object' || field.type_name === 'Object Array') && !field.filter_null);
      });
    },
    simpleFieldFilterPresent() {
      return this.allFields.some((field) => {
        const value = this.filters[field.lookup_key];
        const propsToCheck = (value.view === 'exact') ? ['exact', 'like', 'is_null'] : ['from', 'to'];
        const anyValueFilled = propsToCheck.some((key) => {
          return !this.isEmptyValue(value[key]);
        });
        return field.simple_field && anyValueFilled;
      });
    },
    visibleFields() {
      if (!this.simpleFieldFilterPresent) {
        return this.allFields.filter((field) => {
          return field.simple_field;
        });
      }

      return this.allFields;
    },
  },
  watch: {
    page: 'getData',
    filters: {
      handler: function () {
        const values = this.allFields.map((field) => {
          const val = this.getValuesForField(field);
          if (Object.keys(val).length === 0) {
            return {};
          }
          return {
            [field.lookup_key]: this.getValuesForField(field),
          };
        }).reduce((acc, cur) => ({ ...acc, ...cur }), {});
        this.$emit('updated', values);
      },
      deep: true,
    },
  },
  methods: {
    loadFilters() {
      this.loading = true;
      return Services.detections.filters(this.activeProjectId, this.detectionSetId).then(({ data }) => {
        this.filterFields = data.fields;
        this.filters = data.fields.map((field) => {
          return {
            [field.lookup_key]: {
              exact: (field.type_name === 'Boolean' || field.type_name === 'Boolean Array') ? '' : null,
              view: (field.type_name === 'Timestamp' || field.type_name === 'Timestamp Array') ? 'range' : 'exact',
              from: null,
              to: null,
              like: null,
              is_null: '',
            }
          };
        }).reduce((acc, cur) => ({ ...acc, ...cur }), {});
        Object.keys(data.options).forEach((optionKey) => {
          this.filterOptions[optionKey] = data.options[optionKey].map((opt) => {
            return {
              id: opt,
              label: opt,
            };
          });
        });
        this.loading = false;
      }).catch((err) => { this.loading = false; console.log(err); });
    },
    isNotInObjectArray(item) {
      const regex = /\[\*\]/g;
      const matches = item.lookup_key.match(regex);
      // if item.lookup_key includes [*] once then check also if it is array type
      return (!matches) || (matches && matches.length === 1 && this.isArrayField(item.type_name));
    },
    isArrayField(field) {
      const arrayTypes = ['String Array', 'Number Array', 'Decimal Array', 'Timestamp Array', 'Boolean Array'];
      return arrayTypes.includes(field.type_name);
    },
    isEmptyValue(value) {
      return value === null || value === '' || (typeof (value) === 'object' && value.length === 0);
    },
    getValuesForField(field) {
      const value = this.filters[field.lookup_key];
      let valuesToGater = [];
      switch (value.view) {
        case 'exact':
          if (value.is_null === '') {
            valuesToGater = ['exact', 'like'];
          } else {
            return {
              is_null: value.is_null,
            };
          }
          break;
        case 'range':
          valuesToGater = ['from', 'to'];
          break;
        default:
          return {};
      }

      // for each of vales to collect check if it is empty
      // if not empty add it to the result
      const ret = valuesToGater.reduce((acc, val) => {
        if (!this.isEmptyValue(value[val])) {
          return {
            ...acc,
            [val]: this.parseValue(value[val], field.type_name),
          };
        }
        return acc;
      }, {});
      return ret;
    },
    parseValue(value, typeName) {
      switch (typeName) {
        // case 'Timestamp':
        // case 'Timestamp Array':
        //   return parseInt(value / 1000, 10);
        default:
          return value;
      }
    },
    showNullPicker(field) {
      return field.filter_null && (this.filters[field.lookup_key].view === 'exact' || (field.type_name === 'Timestamp' || field.type_name === 'Timestamp Array'));
    },
  }
};
</script>

<style scoped lang="scss">
.json-filters {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  grid-gap: 1rem;
}

// .json-filter-item {
//   padding: 1rem;
//   border: 1px solid #e2e8f0;
// }

.json-filter-range-group {
  gap: 1rem;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }

  label {
    font-size: 0.8rem;
    margin: 0;
  }
}

.json-filter-range-item {
  gap: 0.5rem;
  align-items: center;
}

.json-filter-label {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-weight: bold;

  label {
    margin: 0;
    line-height: 1rem;
    padding: 0.5rem 0;
  }

  .json-filter-view {
    margin: 0 0 0 1rem;
    width: 5rem;
  }

}

.json-filter-fields {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}

.json-filter-view {
  .btn {
    font-size: 0.8rem;
    padding: 0.2rem 0.2rem;
  }
}

.json-filter-null {
  align-items: center;
  width: 6rem;

  .btn {
    font-size: 0.7rem;
    padding: 0.2rem 0.2rem;
    white-space: nowrap;
  }
}

.json-filter-range-item {
  width: 100%;
}
</style>
